import { css } from "styled-components";

export const contentBorder = css`
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.colors.bg.divider};
  overflow: hidden;
`;
